import React from 'react'
import { AdminSidebar } from './components/AdminSidebar'

interface AdminLayoutProps {
  children: React.ReactNode
  currentPage: string
  onNavigate: (page: string) => void
}

export function AdminLayout({ children, currentPage, onNavigate }: AdminLayoutProps) {
  return (
    <div className="admin-layout">
      <AdminSidebar currentPage={currentPage} onNavigate={onNavigate} />
      <main className="admin-main">
        {children}
      </main>
    </div>
  )
}
